<template>
  <div>
    <CForm @submit.prevent="submit">
      <CModal
        centered
        :close-on-backdrop="false"
        :show.sync="properties.visible"
      >
        <ValidationObserver ref="observer">
          <ValidationProvider
            v-slot="{ errors }"
            name="name"
            rules="required|min:1|max:100"
          >
            <CInput
              label="농장명"
              placeholder="농장명을 입력하세요"
              autocomplete="name"
              horizontal
              v-model="form.name"
              :invalid-feedback="errors.length > 0 ? errors[0] : ''"
              :is-valid="errors.length > 0 ? false : null"
            >
            </CInput>
          </ValidationProvider>

          <ValidationProvider
            v-slot="{ errors }"
            name="inFacilityKindCode"
            rules="required"
          >
            <CSelect
              label="내부시설 유형"
              placeholder="내부시설 유형를 선택하세요"
              horizontal
              :value.sync="form.inFacilityKindCode"
              :options="inFacilityKindCodeList"
              :invalid-feedback="errors.length > 0 ? errors[0] : ''"
              :is-valid="errors.length > 0 ? false : null"
            >
            </CSelect>
          </ValidationProvider>

          <ValidationProvider
            v-slot="{ errors }"
            name="dongSize"
            rules="required"
          >
            <CInput
              label="동 수"
              placeholder="동 수를 입력하세요"
              type="number"
              horizontal
              v-model="form.dongSize"
              :invalid-feedback="errors.length > 0 ? errors[0] : ''"
              :is-valid="errors.length > 0 ? false : null"
            >
              <template #append-content>개</template>
            </CInput>
          </ValidationProvider>

          <ValidationProvider
            v-slot="{ errors }"
            name="inFacilityKindCode"
            rules="required"
          >
            <CSelect
              label="작물"
              placeholder="작물을 선택하세요"
              horizontal
              :value.sync="form.cropCode"
              :options="cropCodeList"
              :invalid-feedback="errors.length > 0 ? errors[0] : ''"
              :is-valid="errors.length > 0 ? false : null"
            >
            </CSelect>
          </ValidationProvider>
        </ValidationObserver>

        <template #header>
          <h5 class="modal-title">농장 추가</h5>
          <CButtonClose @click="properties.visible = false"></CButtonClose>
        </template>
        <template #footer>
          <CButton @click="properties.visible = false" color="secondary">
            취소
          </CButton>
          <CButton type="submit" color="success"> 저장</CButton>
        </template>
      </CModal>
    </CForm>
  </div>
</template>

<script>
import {
  extend,
  localize,
  ValidationObserver,
  ValidationProvider,
} from "vee-validate";
// import MixinsModalBackButton from "@/mixins/modal-back-button";
import { max, min, required } from "vee-validate/dist/rules";
import Constant from "@/store/constant";
import core from "@/core";
import FacilityService from "@/services/facility/facility.service";
import CodeService from "@/services/code/code.service";
import MixinsModalBackButton from "@/mixins/modal-back-button";

extend("required", required);
extend("min", min);
extend("max", max);

localize("ko", {
  messages: Constant.validate.language.korea.messages,
  names: {
    name: "농장명",
    inFacilityKindCode: "내부시설 유형",
    dongSize: "동 수",
  },
});

export default {
  name: "AddEditFacilityModal",
  mixins: [MixinsModalBackButton()],
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    properties: {
      type: Object,
      default: () => {
        return {
          visible: false,
          params: {},
          watchClose: {
            result: "",
            item: null,
          },
        };
      },
    },
  },
  data() {
    return {
      internalFacilityIndex: 0,
      form: {
        name: "",
        inFacilityKindCode: "",
        dongSize: "",
        cropCode: "",
      },
      cropCodeList: [],
      inFacilityKindCodeList: [
        {
          label: "단동",
          value: "S",
        },
        {
          label: "연동",
          value: "M",
        },
      ],
    };
  },
  created() {
    console.log("created");

    CodeService.getCropCodeList().then((cropCodeList) => {
      cropCodeList.forEach((codeItem) => {
        this.cropCodeList.push({
          label: codeItem.koName,
          value: codeItem.code,
        });
      });
    });

    if (this.properties.params.type === "edit") {
      const facility = this.properties.params.item;
      this.form.inFacilityKindCode = facility.dongType;
      this.form.cropCode = facility.cropCode;
      this.form.dongSize = facility.dongSize;
      this.form.name = facility.name;
    }

  },
  computed: {},
  watch: {
    "form.name"() {
      this.changeValue();
    },
  },
  methods: {
    changeValue(changed) {
      const $this = this;
      if (changed != null) {
        $this.backButton.changed = changed;
      } else {
        $this.backButton.changed = true;
      }
    },
    async submit() {
      const observer = this.$refs.observer;
      const isValid = await observer.validate();
      if (isValid) {
        core.loader.show();
        const params = core.utils.deepCopy(this.form);
        try {
          let result = null;
          if (this.properties.params.type === "add") {
            result = await FacilityService.create(params);
          }
          else {
            result = await FacilityService.update(this.properties.params.item.id, params);
          }
          console.log("result : ", result);
          this.properties.watchClose = {
            result: "confirm",
          }
          this.properties.visible = false;
        } catch (e) {
          console.log("error : ", e);
          const errorFieldName = e.errorFieldName;
          if (errorFieldName != null) {
            const errors = observer.errors[errorFieldName];
            if (errors != null) {
              errors.push(e.message);
            } else {
              console.log(`not found error field '${errorFieldName}'`);
            }
            console.log(observer.errors);
          }
        }
        core.loader.hide();
      } else {
        console.log("errors : ", observer.errors);
      }
    },
  },
};
</script>
